<template>
  <div class="w-full">
    <div class="w-full overflow-hidden">
      <div class="w-1/2 inline-block relative fluentProgressBar-waiting"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-progress-bar'
}
</script>

<style>
.fluentProgressBar-waiting {
  background: rgba(89, 192, 237, 0);
  background: -moz-linear-gradient(left, rgba(89, 192, 237, 0) 0%, rgba(89, 192, 237, 1) 51%, rgba(89, 192, 237, 0) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgb(89, 192, 237)), color-stop(51%, rgba(89, 192, 237, 1)), color-stop(100%, rgba(89, 192, 237, 0)));
  background: -webkit-linear-gradient(left, rgba(89, 192, 237, 0) 0%, rgb(89, 192, 237) 51%, rgba(89, 192, 237, 0) 100%);
  background: -o-linear-gradient(left, rgba(89, 192, 237, 0) 0%, rgb(89, 192, 237) 51%, rgba(89, 192, 237, 0) 100%);
  background: -ms-linear-gradient(left, rgba(89, 192, 237, 0) 0%, rgb(89, 192, 237) 51%, rgba(89, 192, 237, 0) 100%);
  background: linear-gradient(to right, rgba(89, 192, 237, 0) 0%, rgb(89, 192, 237) 51%, rgba(89, 192, 237, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0078d4', endColorstr='#0078d4', GradientType=1);
  height: 4px;
  -webkit-animation: progressBarAnimation 2s linear infinite;
  animation: progressBarAnimation 2s linear infinite;
}

@keyframes progressBarAnimation {
  0% {
    left: -50%;
  }
  100% {
    left: 100%;
  }
}
</style>
